export default __webpack_public_path__ + "static/char-s-41-en-ef8662af7d651cb53236338f4dbcd6b4.webp";